import fetch from 'node-fetch'
import QueryString from 'query-string'

export default class Workbench {
  constructor(address = '') {
    // empty address defaults to same schema/domain as current browser page, which will typically be correct
    this.address = address
  }

  static _queryStringParams(params, namespace=[]) {
    return Object.keys(params).reduce((acc, k) => {
      const keys = namespace.concat([k])
      const newKey = keys[0] + keys.splice(1).map(k => `[${k}]`).join("")
      if (typeof params[k] === 'object' && params[k] !== null) {
        Object.assign(acc, this._queryStringParams(params[k], namespace.concat(k)))
      } else
        acc[newKey] = params[k]

      return acc
    }, {})
  }

  configItem(name) {
    return this.getReqData('/configs/lookup', { key: name})
      .then((resp) => resp.val)
  }

  getReq(path, params) {
    return fetch(this._urlWithQueryParams(path, params))
      .catch((err) => err)
  }

  getReqData(path, params) {
    return this.getReq(path, params)
      .then((response) => response.json())
      .catch((err) => console.log('err', err))
  }

  postReq(path, params) {
    return fetch(
      `${this.address}${path}`,
      {
        method: 'post',
        body: JSON.stringify(params),
        headers: { 'Content-Type': 'application/json' },
      })
  }

  _urlWithQueryParams(path, params = {}) {
    return QueryString.stringifyUrl({
      url: `${this.address}${path}`,
      query: Workbench._queryStringParams(params)
    })
  }


}
